// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { WhatsappService } from "src/app/whatsapp.service";

export const environment = {
  production: false,
  environment: 'UAT',
  googleCloudProjectNumber: 975522828247,
  enableTestButton: false,
  hostName: 'https://danaplus-uat.hijrahselangor.com',
  channel: {
    id: 'yhs-lms'
  },
  myInfo: {
    redirectUrl: 'no_use',
    authURL: 'no_use',
    clientId: 'no_use'
  },
  apiUrl: {
    name: 'yhs-api-gateway',
    hostName: 'https://dlms-api-uat.hijrahselangor.com/yhs-uat-dev/api',
    hostUrl: 'https://dlms-api-uat.hijrahselangor.com/yhs-uat-dev/api',
/*     hostName: 'https://newchen-dev-api.imocha.com.my/api',
 */    apiPath: {
      hirePurchase: '/HirePurchaseDetail',
      emergencyContact: '/emergencyContact',
      currentEmploymentDetail: '/currentEmploymentDetail',
      pastEmploymentDetail: '/pastEmploymentDetail',
      user: '/userProfiles',
      userProfiles: '/userProfiles',
      code: '/code',
      financialDetail: '/financialDetail',
      documentCheckList: '/documentCheckList',
      agentList: '/agentList',
      address: '/address',
      clientAddress: '/clientAddress',
      productLoan: '/LoanProducts',
      hirePurchaseProduct: '/HirePurchaseProducts',
      hirePurchaseLoanDetail: '/hirePurchaseLoanDetail',
      onboardingDraft: '/onboardingDraft',
      guarantor: '/guarantor',
      drawdown: '/drawdown',
      guarantorFinancialDetail: '/guarantorFinancialDetail',
      social: '/social',
      ctos: '/ctos',
      portfolioCommandSource: '/portfolioCommandSource',
      guarantorConsent: '/guarantorConsent',
      ringgitPay: '/ringgitPay',
      loanApplication: '/loanApplication',
      company: '/company',
      creditLimits: '/creditLimits',
      drawdowns: '/drawdown',
      loanProduct: '/LoanProducts',
      repayment: '/repayment',
      statement: '/statement',
      termLoanAgreement: '/TermLoanAgreements',
      creditFacilityAgreement: '/CreditFacilityAgreements',
      termLoanEmail: '/email/createTermLoanEmail',
      creditFacilityEmail: '/email',
      signature: '/signature',
      guarantorAgreement: '/GuarantorAgreements',
      guarantorAgreementForCreditFacility: '/GuarantorAgreements/createAgreementGuarantorCreditFacility',
      appVersion: '/appVersion',
      singpass: '/singPass',
      credolab: '/userCredo',
      appVersions: '/appVersions',
      myInfo: '/myInfo',
      myInfoPersonalProfile: '/myInfoPersonalProfile',
      myInfoBusProfile: '/myInfoBusProfile',
      myInfoAdditionalInfo: '/myInfoAdditionalInfo',
      siteVisit: '/siteVisit',
      clientDefault: '/clientDefault',
      loanClient: '/loanClient',
      whatsappService: '/social/whatApp/message',
      mikrokreditUserProfile: '/mikrokreditUserProfile',
      mikrokreditLoan: '/mikrokreditLoan',
      consentReg: '/ambank/consentReg',
      ambankstatus: '/ambankstatus',
      autoDebitAcceptance: '/autoDebitAcceptanceHistory',
      office: '/Office',
      auth: '/auth',
      globalConfiguration: '/globalConfiguration',
      appSettings: '/app-settings',
      clientSupport: '/clientsupport',
      playIntegrityCheck: '/playIntegrityCheck',
      earlySettlement: '/earlySettlement',
      ekyc: '/ekyc',
      recaptcha: '/recaptcha',
      sendwhatsapp: '/social/sendWhatsapp'
    }
  },
  fineract: {
    baseUrl: 'https://dlms-api-uat.hijrahselangor.com/yhs-uat-dev/fineract-provider/api/v1',
    authorization: 'Basic bWlmb3M6cGFzc3dvcmQ=',
    tenantId: 'default'
  },
  ekyc: {
    ekycApiKey: 'kzgpgr1wgvk11j82zggtzis35n68e73f',
    apiBaseUrl: 'https://35ekwskhs8.execute-api.ap-southeast-5.amazonaws.com/api/case-api/api/v2'
    // apiBaseUrl: 'https://devapi-ost.imocha.com.my/case-api/api/v2'
  },
  aws: {
    // sharng the same bucket
    s3: {
      bucket: "yhs-uat-storage-s3",
      securityLevel: "public",
      region: 'ap-southeast-5',
      applicantDocument: {
        clientFolder: "client/applicantDocument",
        agentFolder: "agent/applicantDocument"
      }
    },
    agent: {
      cognito: {
        identity_pool: {
          identity_pool_id: 'ap-southeast-1:45c33616-ed00-472f-8b39-2a5d43c4d64c',
          region: 'ap-southeast-1',
        },
        user_pool: {
          user_pool_id: 'ap-southeast-1_ShbvXbkZf',
          app_client_id: '6cfdg204csfkgv3d20lg83uatn',
          region: 'ap-southeast-1',
        }
      }
    },
    customer: {
      cognito: {
        identity_pool: {
          identity_pool_id: 'ap-southeast-1:ce94aef6-3acf-4c17-a3e9-97e4bd7575c7',
          region: 'ap-southeast-1',
        },
        user_pool: {
          user_pool_id: 'ap-southeast-1_7S6emsD1C',
          app_client_id: '2c7n7rvu9mvje3h3p0hsboh19f',
          region: 'ap-southeast-1',
        }
      }
    },
    cognito: {
      user_pool: {
        region: 'no_use',
        user_pool_id: 'no_use',
        app_client_id: 'no_use'
      },
      identity_pool: {
        region: 'no_use',
        identity_pool_id: 'no_use'
      }
    }
  },
  wordpress: {
    // api_url: "https://dev-wordpress.iremya.com/wp-json/wp/v2/",
    // auth_url: "https://dev-wordpress.iremya.com/wp-json/jwt-auth/v1/token"
    api_url: " ",
    auth_url: " "
  },
  productLoan: {
    financialDetailFormProductLoanId: 1
  },
  supportFeature : {
    // dummy first
    sendWhatsappBaseUrl : "https://wa.me/",
    supportEmail: 'dlms.admin@hijrahselangor.com',
    supportWhatsapp: '60163378392',
  },
  recaptcha: {
    siteKey: '6Lcffh4sAAAAABQLpncACPW3VjmeSAAHHu4Yb0O2'
  },

  webUrl: 'http://localhost:8100',
  backOfficeUrl: 'http://dlms-bo-uat.hijrahselangor.com/'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
